import {MissingTranslationHandler, MissingTranslationHandlerParams} from "@ngx-translate/core";

export class BlankForMissingTranslationHandler implements MissingTranslationHandler {
    handle(params: MissingTranslationHandlerParams): any {
        return '';
    }
}